<template>
  <BaseButton :data-test="dataTest" size="sm" @click="$emit('click')">
    <WdsCheckbox :indeterminate="isPartiallySelected" :checked="isAllSelected" @click.prevent />
    <span class="m-l-10">
      {{ isPartiallySelected ? $t(':count selected', { count: selectedCount }) : $t('Select all') }}
    </span>
  </BaseButton>
</template>

<script>
import { WdsCheckbox } from '@worksome/wds-components'
import BaseButton from '@/components/BaseButton.vue'

/**
 * Select all button<br>
 * Checkbox state is computed based on props
 * @emits click
 */
export default {
  components: { BaseButton, WdsCheckbox },
  props: {
    selectedCount: {
      type: Number,
      default: 0,
    },
    totalCount: {
      type: Number,
      default: 0,
    },
    dataTest: {
      type: String,
      default: 'select-all',
    },
  },
  emits: ['click'],
  computed: {
    isAllSelected() {
      return Boolean(this.selectedCount) && this.selectedCount === this.totalCount
    },
    isPartiallySelected() {
      return Boolean(this.selectedCount) && this.selectedCount !== this.totalCount
    },
  },
}
</script>
